import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from '../src/pages/base/App'
// import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'
import * as atatus from 'atatus-spa'
import { getConfigDetails } from './services/config'

console.log(window?.location?.toString())

// CONDITIONS FOR REDIRECTING TO THE BREEZE SELF URLS
if('https://staging-transient.parkengage.com/pci/touchless-parking-parking/eyJmYWNpbGl0eV9pZCI6NDI0LCJnYXRlIjoxMX0=' == window.location.toString()){
	window.location.href = 'https://staging-pci.breezeparking.com/pci/touchless-parking-parking/eyJmYWNpbGl0eV9pZCI6NDI0LCJnYXRlIjoxMX0='
}else if('https://transient.parkengage.com/pci/touchless-parking-parking/eyJmYWNpbGl0eV9pZCI6MTUzLCJnYXRlIjoxMX0=' == window.location.toString()){
	window.location.href = 'https://pci.breezeparking.com/pci/touchless-parking-parking/eyJmYWNpbGl0eV9pZCI6MTUzLCJnYXRlIjoxMX0='
}else if('https://transient.parkengage.com/parkingpayments/touchless-parking-parking/eyJmYWNpbGl0eV9pZCI6MTQ0LCJnYXRlIjoxMX0=' == window.location.toString()){
	window.location.href = 'https://park2visit.com/FL357' //https://outworx.atlassian.net/browse/PIMS-15218
}else if(window?.location?.toString()?.includes('/revpass') && window?.location?.toString()?.includes('parkengage.com')){
	window.location.href = getConfigDetails()?.revtransientURL+'/revpass'+window.location.href.split('/revpass')[1]
}
else{

	const root = ReactDOM.createRoot(document.getElementById('root'))
	atatus.config('5ce6a053f8ca4a9cac5c1dbba15b1ecc').install()
	root.render(process.env.NODE_ENV === 'development' ? <Provider store={configureStore()}>
			<App />
		</Provider> : <React.StrictMode>
		<Provider store={configureStore()}>
			<App />
		</Provider>
	</React.StrictMode> 
	)
}


